export class UpdateCityCommand {
    public id: string;
    public image: File;
    public imageBase64: string;
    public order: number;
    public cityTitle: string;
}


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/commands/hub/update.city.command.ts